// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Viewed_wrapper__XbZHY","content":"Viewed_content__2Cxhi","actions":"Viewed_actions__2LLkL","borderV":"Viewed_borderV__1Fn2v"};